module.exports = __webpack_public_path__ + "img/twinkle-star.0e2f628d.svg";